var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.93,
    height: 16.829,
    viewBox: "0 0 18.93 16.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Edit",
    d: "M13.222,11.263l1.052-1.052a.264.264,0,0,1,.45.187v4.779a1.578,1.578,0,0,1-1.578,1.578H1.578A1.578,1.578,0,0,1,0,15.177V3.608A1.578,1.578,0,0,1,1.578,2.031h8.989a.265.265,0,0,1,.187.45L9.7,3.533a.261.261,0,0,1-.187.076H1.578V15.177H13.146v-3.73A.258.258,0,0,1,13.222,11.263ZM18.368,4.63l-8.63,8.63-2.971.329a1.358,1.358,0,0,1-1.5-1.5L5.6,9.12l8.63-8.63a1.918,1.918,0,0,1,2.718,0l1.42,1.42a1.925,1.925,0,0,1,0,2.721ZM15.121,5.646,13.212,3.737,7.105,9.846l-.24,2.146,2.146-.24Zm2.13-2.619-1.42-1.42a.343.343,0,0,0-.486,0L14.329,2.622l1.909,1.909,1.016-1.016A.35.35,0,0,0,17.251,3.027Z",
    transform: "translate(0 0.075)",
    fill: "#2280be"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.18978b326b4c468f2a1542c6e48696e4.svg";
export { ForwardRef as ReactComponent };